import { useEffect, useState, useMemo } from 'react';
import { convertListToSelectOptions, IConvertToSelectOptionsOptions, IDatasource } from 'src/components/TitledAutoComplete/utils';

export default function useMapArrayToSelectOptions<T>(ds: IDatasource<T>, options: IConvertToSelectOptionsOptions<T>) {
  return useMemo(() => convertListToSelectOptions(ds, options), [ds]);
}
